app.controller('cadSyncTableController', async function ($rootScope, $scope, $filter, safeApply, propertyService, cadSyncService) {
  let initialized = false
  let agent_id = null
  let uploadToGCS = null
  let actions_modal_ref = null

  const SHOW_TOOLTIPS = true

  const aoaTable = '#cad_sync_table'
  const actions_modal = 'actions_modal'
  const host = "https://api.propertytax.io"
  const currentDate = new Date()
  const CurrentYear = currentDate.getFullYear()

  $scope.currentFilterDays = 0
  $scope.currentCounty = { name: 'Collin', cad_code: '043', filter_days: $scope.filter_days }
  $scope.currentCountyOptions = null
  $scope.currentFiletype = null

  // Add filter days options
  $scope.filterDaysOptions = [
    { label: 'SHOW ALL RECORDS', value: 0 },
    { label: 'No actions in 1 day', value: 1 },
    { label: 'No actions in 3 days', value: 3 },
    { label: 'No actions in 5 days', value: 5 },
    { label: 'No actions in 7 days', value: 7 },
    { label: 'No actions in 10 days', value: 10 },
  ];

  // Add current filter days display
  $scope.currentFilterDays = $scope.filterDaysOptions[0]; // Default to 'ALL'

  // Add resize handler variable
  let resizeTimeout = null;

  // Add function to close dropdowns
  $scope.closeDropdown = function (buttonId) {
    setTimeout(function () {
      const button = document.getElementById(buttonId);
      if (button) {
        // First try to get existing dropdown instance
        let dropdown = bootstrap.Dropdown.getInstance(button);

        if (dropdown) {
          dropdown.hide();
        } else {
          // If no instance exists, create one and hide it
          try {
            dropdown = new bootstrap.Dropdown(button);
            dropdown.hide();
          } catch (error) {
            console.log('Could not create dropdown instance:', error);
            // Fallback: manually close by removing the show class
            const dropdownMenu = button.nextElementSibling;
            if (dropdownMenu) {
              dropdownMenu.classList.remove('show');
              button.setAttribute('aria-expanded', 'false');
              button.classList.remove('show');
            }
          }
        }
      }
    }, 500)
  };

  $scope.set_filter_days = function (days) {
    if ($scope.currentFilterDays.value === days) {
      console.log('Filter days value unchanged, skipping reload');
      return
    }
    $scope.currentFilterDays = $scope.filterDaysOptions.find(option => option.value === days);
    cadCodeChange()
    safeApply($scope)
  }

  $scope.setCounty = function (county) {
    console.log('county :>> ', county);
    $scope.currentCounty = { name: county.county, cad_code: county.cad_code }
    $scope.currentCountyOptions = county.cad_options
    $scope.currentFiletype = null

    // Clear existing DataTable first
    if ($scope.cadSyncDataTable) {
      $scope.cadSyncDataTable.destroy();
      $('#cad_sync_table_issues tbody').empty();
      $scope.cadSyncDataTable = null;
    }

    cadCodeChange()
    safeApply($scope)
  }

  $scope.copyToClipboard = function (value) {
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(value);
    } else {
      var tempInput = document.createElement('input');
      tempInput.value = value;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
    }
  }

  $scope.pasteFromClipboard = async function (fieldName) {
    try {
      if (navigator && navigator.clipboard && navigator.clipboard.readText) {
        const text = await navigator.clipboard.readText()
        switch (fieldName) {
          case 'cancel_service':
            $scope.modal_action_issue.reason_for_cancellation = text;
            break;
          case 'other_agent_name':
            $scope.modal_action_issue.other_agent_name = text;
            break;
          case 'owner_name_cad':
            $scope.modal_action_issue.owner_name_cad = text;
            break;
        }
        safeApply($scope);
      } else {
        alert('Clipboard access not supported in this browser. Please paste manually using Ctrl+V.');
      }
    } catch (error) {
      console.error('Failed to read clipboard:', error);
      alert('Unable to access clipboard. Please paste manually using Ctrl+V.');
    }
  }

  $scope.clearField = function (fieldName) {
    switch (fieldName) {
      case 'cancel_service':
        $scope.modal_action_issue.reason_for_cancellation = '';
      case 'other_agent_name':
        $scope.modal_action_issue.reason_for_cancellation = '';
        $scope.modal_action_issue.send_email_to_client = false;
        break;
      case 'other_agent_name':
        $scope.modal_action_issue.other_agent_name = '';
        break;
      case 'owner_name_cad':
        $scope.modal_action_issue.owner_name_cad = '';
        break;
    }
    safeApply($scope);
  }

  $scope.openActionsModal = function (index1, index2) {
    $scope.action_panel_to_display = 'main'
    $scope.modal_action_index1 = index1
    $scope.modal_action_index2 = index2
    $scope.modal_action_test_name = $scope.cadIssues[index1].tests[index2].test_display_name
    $scope.modal_action_file_id = $scope.cadIssues[index1].tests[index2].test_type_id
    $scope.modal_action_issue = $scope.cadIssues[index1]
    $scope.modal_action_issue.owner_name_cad = ""
    $scope.modal_action_test = $scope.cadIssues[index1].tests
    $scope.modal_action_issues_id = $scope.cadIssues[index1].tests[index2].issues_id
    $scope.modal_action_actions = $scope.cadIssues[index1].tests[index2].actions
    $scope.modal_action_new_item = { title: '', description: '' }

    // Load notes for this issue
    loadNotesForIssue($scope.modal_action_issues_id);

    console.log('***** $scope.modal_action_issue :>> ', $scope.modal_action_issue);

    actions_modal_ref.show()
  }

  $scope.createAction = function (modal_action_file_id, action_panel_to_display) {
    console.log('****** modal_action_file_id    :>> ', modal_action_file_id);
    console.log('****** action_panel_to_display :>> ', action_panel_to_display);
    switch (modal_action_file_id) {
      case 1: // Authorization
        $scope.action_panel_to_display = action_panel_to_display
        $scope.clearField(action_panel_to_display)
        safeApply($scope)
        break
    }
    safeApply($scope)
  }

  $scope.processDocument = function (link) {
    window.open(link, '_blank')
  }

  $scope.performActions = async function () {
    const mai = $scope.modal_action_issue

    let __title = '', __description = ''
    let sendEmailResults
    let cancelServiceResults
    let csObj

    console.log('$scope.modal_action_issue :>> ', $scope.modal_action_issue)

    switch ($scope.action_panel_to_display) {
      case "name_change":
        // Send email and log it.
        __title = 'Name Change'
        __description = `Email Sent - Ownername: (Original) ${mai.owner_name_ptio} -> (CAD) ${mai.owner_name_cad}`
        sendEmailResults = await cadSyncService.sendEmail({
          'user_id': mai.user_id,
          'prop_id': mai.prop_id,
          'cad_owner_name': mai.owner_name_cad,
          'tax_year': '2025',
          'record_wh_events': 'false',
          'update_db': 'false',
          'send_email': 'true',
          'test_mode': 'true',
          'test_email': 'bryanutley2000@yahoo.com',
          'is_preview': 'false',
          'email_id': '7000'
        })
        if (!sendEmailResults.data.success) {
          alert('Error saving action')
          return
        }
        console.log('sendEmailResults :>> ', sendEmailResults);
        break
      case 'property_sold':
        csObj = {
          user_id: mai.user_id,
          business_source: mai.business_source,
          prop_id: mai.prop_id,
          appeal_id: mai.appeal_id,
          cad_code: mai.cad_code,
          account: mai.cad_account,
          reason: "Sold property - action performed by CAD_SYNC.",
          return_pdf_blob: false,
          email_client: false,
          email_cad: false,
          withdraw_protest: false
        }
        console.log('csObj :>> ', csObj);
        // alert("Has return to prevent actual email going out and canceling a service we don't want to.")
        // return
        // break

        cancelServiceResults = await propertyService.cancelService(csObj)
        if (cancelServiceResults.data.success) {
          toastr.success("The service has been cancelled, refreshing client and property data.", "Service Cancelled", { timeOut: 8000 })
        } else {
          toastr.error("There was an error processing 'Cancel Service' request!", "Error", { timeOut: 15000 })
        }

        return
        break

      case 'cancel_service':
        // Cancel Service in DB, Send email and log it.
        __title = 'Cancel Service'
        __description = `Cancel Service - Removed Authorization - ${mai.send_email_to_client ? 'Email was Sent to Client.' : 'Email was NOT sent to Client.'}`

        csObj = {
          user_id: mai.user_id,
          prop_id: mai.prop_id,
          reason: reason_for_cancellation,
          return_pdf_blob: false,
          email_client: mai.send_email_to_client ? true : false,
          email_cad: false,
          withdraw_protest: true
        }
        console.log('csObj :>> ', csObj)

        cancelServiceResults = await propertyService.cancelService(csObj)
        if (cancelServiceResults.data.success) {
          toastr.success("The service has been cancelled, refreshing client and property data.", "Service Cancelled", { timeOut: 8000 })
        } else {
          toastr.error("There was an error processing 'Cancel Service' request!", "Error", { timeOut: 15000 })
          return
        }
        console.log('cancelServiceResults :>> ', cancelServiceResults);

        let updateIssueResolvedResults = await cadSyncService.updateIssueResolved({
          issues_id: $scope.modal_action_issues_id
        })
        console.log('updateIssueResolvedResults :>> ', updateIssueResolvedResults);
        if (!updateIssueResolvedResults.data.success) {
          toastr.error("There was an error updating the issue resolution status!", "Error", { timeOut: 15000 })
        }

        // remove return for production
        // Otherwise logging will no take place
        // return
        break


      case 'other_agent':
        // Send email that another agent is listed by the CAD and log it
        __title = 'Other Agent'
        __description = `Email Sent - letting the client know that another agent is currently assigned to their property.`
        sendEmailResults = await cadSyncService.sendEmail({
          'user_id': mai.user_id,
          'prop_id': mai.prop_id,
          'cad_owner_name': mai.owner_name_cad,
          'tax_year': '2025',
          'record_wh_events': 'false',
          'update_db': 'false',
          'send_email': 'true',
          'test_mode': 'true',
          'test_email': 'bryanutley2000@yahoo.com',
          'is_preview': 'false',
          'email_id': '7010',
          current_agent_name: mai.other_agent_name
        })
        if (!sendEmailResults.data.success) {
          alert('Error saving action')
          return
        }
        break
      case 'no_agent':
        // Send email that no agent is listed by the CAD and log it (maybe they removed us or ??)
        __title = 'No Agent'
        __description = `Email Sent - letting the client know that no agent is currently assigned to their property.`
        sendEmailResults = await cadSyncService.sendEmail({
          'user_id': mai.user_id,
          'prop_id': mai.prop_id,
          'cad_owner_name': mai.owner_name_cad,
          'tax_year': '2025',
          'record_wh_events': 'false',
          'update_db': 'false',
          'send_email': 'true',
          'test_mode': 'true',
          'test_email': 'bryanutley2000@yahoo.com',
          'is_preview': 'false',
          'email_id': '7020'
        })
        if (!sendEmailResults.data.success) {
          alert('Error saving action')
          return
        }
        break
      case 'custom_action':
        // Not sure what this is for, but it's here
        break
    }
    $scope.modal_action_new_item = { title: __title, description: __description }
    $scope.saveAction()
  }

  $scope.saveAction = async function () {
    const obj = {
      issues_id: $scope.modal_action_issues_id,
      title: $scope.modal_action_new_item.title,
      description: $scope.modal_action_new_item.description,
    }
    const saveActionResults = await cadSyncService.saveAction(obj)
    console.log("*********************************");
    console.log('saveActionResults.data.data[0] :>> ', saveActionResults.data.data[0]);
    console.log("*********************************");

    if (!saveActionResults.data.success) {
      alert('Error saving action')
      return
    }

    $scope.resetActionPanel()
    $scope.cadIssues[$scope.modal_action_index1].tests[$scope.modal_action_index2].actions.unshift(saveActionResults.data.data[0])
    safeApply($scope)
  }

  $scope.getIssueTooltip = function (index1, index2) {
    if (!initialized) return ''
    return `<div style="line-height: 1.5; color: white; border-radius: 5px; box-shadow: 2px 2px 3px rgba(0,0,0,.1); font-size: 12px; min-width: 150px; max-width: 250px;">
              <div style="font-size: 14px; font-weight: bold;">${$scope.cadIssues[index1].tests[index2].test_display_name}</div>
              <div style="display: flex; justify-content: space-between; margin-top: 12px;">
                <div>Test Type ID:</div>
                <div style="font-weight: bold;">${$scope.cadIssues[index1].tests[index2].test_type_id}</div>
              </div>
              <div style="display: flex; justify-content: space-between;">
                <div>Upload ID:</div>
                <div style="font-weight: bold;">${$scope.cadIssues[index1].tests[index2].upload_id}</div>
              </div>
              <div style="display: flex; justify-content: space-between;">
                <div>File ID:</div>
                <div style="font-weight: bold;">${$scope.cadIssues[index1].tests[index2].file_id}</div>
              </div>
              <div style="display: flex; justify-content: space-between;">
                <div>Result ID:</div>
                <div style="font-weight: bold;">${$scope.cadIssues[index1].tests[index2].result_id}</div>
              </div>
              <div style="display: flex; justify-content: space-between;">
                <div>Actions:</div>
                <div style="font-weight: bold;">${$scope.cadIssues[index1].tests[index2].actions.length}</div>
              </div>
              <div>
                <div>Comment:</div>
                <div>${$scope.cadIssues[index1].tests[index2].comment || ""}</div>
              </div>
              <div style="font-size: 10px; text-align: center; margin-top: 10px; border-top: 1px solid gray; padding-top: 5px;">
                <div style="font-weight: normal;">${moment($scope.cadIssues[index1].tests[index2].created_at).format("YYYY-MM-DD hh:mm A")}</div>
                <div>Created</div>
              </div>
            </div>`
  }

  // Pulls in user info from the rootScope -> CRMController
  $rootScope.$watch('user_info', function () {
    $scope.user_info = $rootScope.user_info
    console.log('$scope.user_info :>> ', $scope.user_info);
  }, true)

  // Calculate available height for the DataTable - updated to use full viewport
  function calculateDataTableHeight() {
    const windowHeight = $(window).height();

    // Get actual heights of elements - now measuring from the top of the page
    const pageHeaderHeight = $('.navbar, .header, .page-header').outerHeight(true) || 60; // Main navigation/header
    const panelHeaderHeight = $('.panel-header, .page-title').outerHeight(true) || 40; // Panel title area
    const panelContentPadding = $('.panel-content').outerHeight(true) - $('.panel-content').height() || 20; // Panel content padding/margins
    const dataTableTopControls = $('.dataTables_wrapper .top').outerHeight(true) || 90; // Search, length, buttons
    const dataTableBottomControls = 155; // Space for pagination and info
    const scrollbarPadding = 20; // Account for scrollbars
    const safetyPadding = 30; // Reduced safety padding since we're using full viewport

    // Calculate available height from full viewport
    const availableHeight = windowHeight - pageHeaderHeight - panelHeaderHeight - panelContentPadding - dataTableTopControls - dataTableBottomControls - scrollbarPadding - safetyPadding;
    const minHeight = 200; // Minimum height to ensure usability
    return Math.max(minHeight, availableHeight);
  }

  // Add window resize handler function
  function handleWindowResize() {
    // Clear existing timeout
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }

    // Debounce resize events to avoid excessive calls
    resizeTimeout = setTimeout(function () {
      if ($scope.cadSyncDataTable) {
        // Recalculate table height
        const newHeight = calculateDataTableHeight();
        // Destroy and recreate DataTable with new height (more reliable than just updating settings)
        const currentPage = $scope.cadSyncDataTable.page();
        const searchTerm = $scope.cadSyncDataTable.search();
        const orderSettings = $scope.cadSyncDataTable.order();

        // Store current state
        const tableState = {
          page: currentPage,
          search: searchTerm,
          order: orderSettings
        };

        // Destroy current instance
        $scope.cadSyncDataTable.destroy();
        $scope.cadSyncDataTable = null;

        // Recreate with new height
        setTimeout(() => {
          initializeCadSyncDataTable();

          // Restore state after recreation
          setTimeout(() => {
            if ($scope.cadSyncDataTable && tableState.search) {
              $scope.cadSyncDataTable.search(tableState.search);
            }
            if ($scope.cadSyncDataTable && tableState.order) {
              $scope.cadSyncDataTable.order(tableState.order);
            }
            if ($scope.cadSyncDataTable && tableState.page) {
              $scope.cadSyncDataTable.page(tableState.page);
            }
            if ($scope.cadSyncDataTable) {
              $scope.cadSyncDataTable.draw(false);
            }
          }, 100);
        }, 50);
      }
    }, 250); // Increased debounce to 250ms for better performance
  }

  // Cleanup function for controller destruction
  $scope.$on('$destroy', function () {
    // Remove resize event listener
    $(window).off('resize.cadSyncTable');

    // Clear timeout
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }

    // Destroy DataTable
    if ($scope.cadSyncDataTable) {
      $scope.cadSyncDataTable.destroy();
      $scope.cadSyncDataTable = null;
    }
  });

  init()
  async function init() {
    let results = await cadSyncService.loadCadOptions()
    console.log('results :>> ', results);
    if (!results.data.success) {
      alert('Error loading CAD options')
      return
    }
    $scope.cadOptions = results.data.data
    safeApply($scope)
    cadCodeChange()
    initialized = true
    actions_modal_ref = new bootstrap.Modal(document.getElementById(actions_modal))

    // Initialize note modal
    note_modal_ref = new bootstrap.Modal(document.getElementById('note_modal'))

    // Set up window resize handler with namespace to avoid conflicts
    $(window).off('resize.cadSyncTable').on('resize.cadSyncTable', handleWindowResize);
  }

  // Add loading state
  $scope.isLoadingData = false;

  async function cadCodeChange() {
    // Show blur overlay
    $scope.isLoadingData = true;
    safeApply($scope);

    try {
      let cadIssuesResults = await cadSyncService.loadCADIssues({
        cad_code: $scope.currentCounty.cad_code,
        days: $scope.currentFilterDays.value
      });

      console.log('cadIssuesResults :>> ', cadIssuesResults);

      if (!cadIssuesResults.data.success) {
        alert('Error loading CAD issues');
        return;
      }

      $scope.cadIssues = cadIssuesResults.data.data;

      // Clear any existing event handlers to prevent duplicates
      $('#cad_sync_table_issues tbody').off('click', '.expand-row');
      $('#cad_sync_table_issues tbody').off('click', '.test-action-btn');

      // Initialize DataTable after data is loaded
      setTimeout(() => {
        initializeCadSyncDataTable();
      }, 100);

      console.log('$scope.cadIssues :>> ', $scope.cadIssues);

    } catch (error) {
      console.error('Error in cadCodeChange:', error);
      alert('Error loading CAD issues');
    } finally {
      // Hide blur overlay before safeApply
      $scope.isLoadingData = false;
      safeApply($scope);
    }
  }

  $scope.cadSyncDataTable = null;

  // Add variable to track expand/collapse state
  let allRowsExpanded = true; // Start with true since rows are expanded by default

  // Move formatTestsRow function outside so it can be accessed by toggleAllRows
  function formatTestsRow(rowData, cadIndex) {
    const cad = $scope.cadIssues[cadIndex];
    if (!cad || !cad.tests) return '';

    const testsHtml = cad.tests.map((test, testIndex) => {
      return `<button 
                class="btn btn-sm btn-outline-success px-2 py-0 me-1 mb-1 test-action-btn" 
                data-cad-index="${cadIndex}" 
                data-test-index="${testIndex}">
                ${test.test_display_name} - <span style="font-size: 11px">( ${test.actions.length} )</span>
              </button>`;
    }).join(' ');

    return `<table class="table table-sm mb-0 child-tests-table">
              <tr>
                <td style="border: none; padding: 8px;">
                  ${testsHtml}
                </td>
              </tr>
            </table>`;
  }

  // Function to initialize DataTable
  function initializeCadSyncDataTable() {
    // Destroy existing DataTable if it exists
    if ($scope.cadSyncDataTable) {
      // Remove event handlers first
      $('#cad_sync_table_issues tbody').off('click', '.expand-row');
      $('#cad_sync_table_issues tbody').off('click', '.test-action-btn');

      $scope.cadSyncDataTable.destroy();
      $('#cad_sync_table_issues tbody').empty();
      $scope.cadSyncDataTable = null;
    }

    if (!$scope.cadIssues || $scope.cadIssues.length === 0) {
      // If no data, clear the table and show empty state
      $('#cad_sync_table_issues tbody').html('<tr><td colspan="11" class="text-center">No data available</td></tr>');
      return;
    }

    // NOTE: formatTestsRow function is now defined above this function

    // Prepare data for DataTable (without Tests column)
    // Start with minus icon since rows will be expanded by default
    const tableData = $scope.cadIssues.map((cad, index) => {
      return [
        `<i class="fas fa-minus-circle expand-row" style="cursor: pointer; color: #007bff;" data-row-index="${index}"></i>`, // Start with minus icon
        index + 1, // Item
        cad.prop_id || '', // Prop ID
        cad.user_id || '', // User ID
        cad.county_name || '', // County
        cad.cad_code || '', // CAD Code
        cad.cad_account || '', // CAD Account
        cad.name || '', // Client Name
        cad.owner_name_ptio || '', // Owner Name
        cad.situs || '', // Address (Situs)
        cad.num_issues || 0 // Number of Issues
      ];
    });

    // Generate filename with current date and county
    const currentDate = new Date();
    const dateString = currentDate.toISOString().split('T')[0]; // YYYY-MM-DD format
    const filename = `CAD_Sync_Issues_${$scope.currentCounty.name}_${dateString}`;

    // Get the calculated height
    const tableHeight = calculateDataTableHeight();

    // Initialize DataTable
    $scope.cadSyncDataTable = $('#cad_sync_table_issues').DataTable({
      data: tableData,
      destroy: true, // Allow reinitializing
      columns: [
        {
          title: "",
          width: "30px",
          className: "text-center expand-control",
          orderable: false,
          exportable: false, // Don't include expand icons in export
          createdCell: function (td, cellData, rowData, row, col) {
            $(td).css('padding', '8px 4px');
          }
        },
        {
          title: "Item",
          width: "60px",
          className: "text-center dt-head-center dt-body-center",
          createdCell: function (td, cellData, rowData, row, col) {
            $(td).css('padding', '8px 12px');
          }
        },
        {
          title: "Prop ID",
          width: "80px",
          className: "text-left dt-head-left dt-body-left",
          createdCell: function (td, cellData, rowData, row, col) {
            $(td).css('padding', '8px 12px');
          }
        },
        {
          title: "User ID",
          width: "80px",
          className: "text-left dt-head-left dt-body-left",
          createdCell: function (td, cellData, rowData, row, col) {
            $(td).css('padding', '8px 12px');
          }
        },
        {
          title: "County",
          width: "90px",
          className: "text-left dt-head-left dt-body-left",
          createdCell: function (td, cellData, rowData, row, col) {
            $(td).css('padding', '8px 12px');
          }
        },
        {
          title: "CAD Code",
          width: "80px",
          className: "text-left dt-head-left dt-body-left",
          createdCell: function (td, cellData, rowData, row, col) {
            $(td).css('padding', '8px 12px');
          }
        },
        {
          title: "CAD Account",
          width: "120px",
          className: "text-left dt-head-left dt-body-left",
          createdCell: function (td, cellData, rowData, row, col) {
            $(td).css('padding', '8px 12px');
          }
        },
        {
          title: "Client Name",
          width: "140px",
          className: "text-left dt-head-left dt-body-left",
          createdCell: function (td, cellData, rowData, row, col) {
            $(td).css('padding', '8px 12px');
          }
        },
        {
          title: "Owner Name",
          width: "160px",
          className: "text-left dt-head-left dt-body-left",
          createdCell: function (td, cellData, rowData, row, col) {
            $(td).css('padding', '8px 12px');
          }
        },
        {
          title: "Address",
          width: "220px",
          className: "text-left dt-head-left dt-body-left",
          createdCell: function (td, cellData, rowData, row, col) {
            $(td).css('padding', '8px 12px');
          }
        },
        {
          title: "Issues",
          width: "70px",
          className: "text-center dt-head-center dt-body-center",
          createdCell: function (td, cellData, rowData, row, col) {
            $(td).css('padding', '8px 12px');
          }
        }
      ],
      responsive: false,
      scrollX: true,
      scrollY: tableHeight + 'px',
      scrollCollapse: false,
      paging: true,
      pageLength: -1,
      lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
      searching: true,
      ordering: true,
      info: true,
      autoWidth: false,
      dom: '<"top"<"d-flex justify-content-between align-items-center"<"d-flex align-items-center gap-2"lB>f>>rt<"bottom"<"d-flex justify-content-between align-items-center"ip>><"clear">',
      buttons: [
        {
          extend: 'csvHtml5',
          text: '<i class="fas fa-file-csv me-1"></i> Export CSV',
          className: 'btn btn-primary btn-sm me-2', // Added me-2 for gap
          filename: filename,
          title: `CAD Sync Issues - ${$scope.currentCounty.name} County`,
          exportOptions: {
            columns: ':not(.expand-control)' // Exclude the first column (expand icons)
          }
        },
        {
          extend: 'excelHtml5',
          text: '<i class="fas fa-file-excel me-1"></i> Export Excel',
          className: 'btn btn-success btn-sm me-2', // Added me-2 for gap
          filename: filename,
          title: `CAD Sync Issues - ${$scope.currentCounty.name} County`,
          exportOptions: {
            columns: ':not(.expand-control)' // Exclude the first column (expand icons)
          }
        },
        {
          text: '<i class="fas fa-compress-alt me-1"></i> Collapse All',
          className: 'btn btn-secondary btn-sm toggle-rows-btn',
          action: function (e, dt, node, config) {
            toggleAllRows();
          }
        }
      ],
      language: {
        search: "Search:",
        lengthMenu: "Show _MENU_ records",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        infoEmpty: "No records available",
        infoFiltered: "(filtered from _MAX_ total records)"
      },
      initComplete: function () {
        const wrapper = $(this.api().table().container()).closest('.dataTables_wrapper');
        wrapper.css({
          'overflow-x': 'auto',
          'width': '100%'
        });

        wrapper.find('.dataTables_scroll').css({
          'overflow-x': 'auto',
          'width': '100%'
        });

        wrapper.find('.dataTables_scrollBody').css({
          'overflow-x': 'auto',
          'width': '100%'
        });

        wrapper.find('thead th').css({
          'padding': '8px 12px',
          'vertical-align': 'middle'
        });

        wrapper.find('thead th.dt-head-left').css('text-align', 'left');
        wrapper.find('thead th.dt-head-center').css('text-align', 'center');

        // Ensure bottom controls are properly spaced and visible
        wrapper.find('.bottom').css({
          'margin-top': '15px',
          'padding-top': '10px',
          'min-height': '50px',
          'border-top': '1px solid #dee2e6'
        });

        // Fix pagination margin
        wrapper.find('.dataTables_paginate ul.pagination').css({
          'margin-top': '0px'
        });

        // Fix dataTables_info padding-top - ADD THIS LINE
        wrapper.find('.dataTables_info').css({
          'padding-top': '0px'
        });

        // Initial column adjustment after complete initialization
        setTimeout(() => {
          if ($scope.cadSyncDataTable) {
            $scope.cadSyncDataTable.columns.adjust();
          }
        }, 100);
      },
      drawCallback: function () {
        // Expand all rows after each draw (including pagination, search, etc.)
        const api = this.api();
        api.rows().every(function (rowIdx) {
          const row = this;
          const tr = $(row.node());
          const rowIndex = rowIdx;

          if (!row.child.isShown()) {
            row.child(formatTestsRow(row.data(), rowIndex)).show();
            tr.addClass('shown');
            tr.find('.expand-row').removeClass('fas fa-plus-circle').addClass('fas fa-minus-circle');

            // Set the background color of the child row to match the parent
            const childRow = tr.next('tr.child');
            const parentBgColor = tr.css('background-color');
            childRow.css('background-color', parentBgColor);
            childRow.find('td').css('background-color', parentBgColor);
            childRow.find('.child-tests-table').css('background-color', parentBgColor);
            childRow.find('.child-tests-table td').css('background-color', parentBgColor);
          }
        });

        // Update toggle button state after draw
        setTimeout(() => {
          updateToggleButtonState();
        }, 10);

        // Adjust columns after each draw to ensure proper alignment
        setTimeout(() => {
          if ($scope.cadSyncDataTable) {
            $scope.cadSyncDataTable.columns.adjust();
          }
        }, 50);
      }
    });

    // Force initial column adjustment after DOM is ready
    setTimeout(() => {
      if ($scope.cadSyncDataTable) {
        $scope.cadSyncDataTable.columns.adjust();
        // Double adjustment with a delay for stubborn cases
        setTimeout(() => {
          if ($scope.cadSyncDataTable) {
            $scope.cadSyncDataTable.columns.adjust();
          }
        }, 200);
      }
    }, 300);

    $('#cad_sync_table_issues tbody').off('click.cadSync', '.expand-row').on('click.cadSync', '.expand-row', function () {
      const tr = $(this).closest('tr');
      const row = $scope.cadSyncDataTable.row(tr);
      const rowIndex = parseInt($(this).data('row-index'));

      if (row.child.isShown()) {
        // This row is already open - close it
        row.child.hide();
        $(this).removeClass('fas fa-minus-circle').addClass('fas fa-plus-circle');
        tr.removeClass('shown');
      } else {
        // Open this row
        row.child(formatTestsRow(row.data(), rowIndex)).show();
        $(this).removeClass('fas fa-plus-circle').addClass('fas fa-minus-circle');
        tr.addClass('shown');
        // Set the background color of the child row to match the parent
        const childRow = tr.next('tr.child');
        const parentBgColor = tr.css('background-color');
        childRow.css('background-color', parentBgColor);
        childRow.find('td').css('background-color', parentBgColor);
        childRow.find('.child-tests-table').css('background-color', parentBgColor);
        childRow.find('.child-tests-table td').css('background-color', parentBgColor);
      }

      // Update toggle button state based on current row states
      updateToggleButtonState();
    });

    $('#cad_sync_table_issues tbody').off('click.cadSync', '.test-action-btn').on('click.cadSync', '.test-action-btn', function () {
      const cadIndex = parseInt($(this).data('cad-index'));
      const testIndex = parseInt($(this).data('test-index'));

      // Call the Angular scope function
      $scope.openActionsModal(cadIndex, testIndex);

      // Apply scope changes
      safeApply($scope);
    });
  }

  // Function to toggle all rows open/closed
  function toggleAllRows() {
    if (!$scope.cadSyncDataTable) return;

    const api = $scope.cadSyncDataTable;
    const toggleBtn = $('.toggle-rows-btn');

    console.log('toggleAllRows called, allRowsExpanded:', allRowsExpanded); // Debug log

    if (allRowsExpanded) {
      // Collapse all rows
      api.rows().every(function (rowIdx) {
        const row = this;
        const tr = $(row.node());

        if (row.child.isShown()) {
          row.child.hide();
          tr.removeClass('shown');
          tr.find('.expand-row').removeClass('fas fa-minus-circle').addClass('fas fa-plus-circle');
        }
      });

      // Update button text and icon
      toggleBtn.html('<i class="fas fa-expand-alt me-1"></i> Expand All');
      allRowsExpanded = false;
    } else {
      // Expand all rows
      api.rows().every(function (rowIdx) {
        const row = this;
        const tr = $(row.node());
        const rowIndex = rowIdx;

        console.log('Expanding row:', rowIndex); // Debug log

        if (!row.child.isShown()) {
          // Now formatTestsRow is accessible since it's defined outside
          row.child(formatTestsRow(row.data(), rowIndex)).show();
          tr.addClass('shown');
          tr.find('.expand-row').removeClass('fas fa-plus-circle').addClass('fas fa-minus-circle');

          // Set the background color of the child row to match the parent
          const childRow = tr.next('tr.child');
          const parentBgColor = tr.css('background-color');
          childRow.css('background-color', parentBgColor);
          childRow.find('td').css('background-color', parentBgColor);
          childRow.find('.child-tests-table').css('background-color', parentBgColor);
          childRow.find('.child-tests-table td').css('background-color', parentBgColor);
        }
      });

      // Update button text and icon
      toggleBtn.html('<i class="fas fa-compress-alt me-1"></i> Collapse All');
      allRowsExpanded = true;
    }

    // Adjust columns after toggle to ensure proper alignment
    setTimeout(() => {
      if ($scope.cadSyncDataTable) {
        $scope.cadSyncDataTable.columns.adjust();
      }
    }, 50);

    console.log('toggleAllRows completed, new allRowsExpanded state:', allRowsExpanded); // Debug log
  }

  // Function to update toggle button state based on current row visibility
  function updateToggleButtonState() {
    if (!$scope.cadSyncDataTable) return;

    const api = $scope.cadSyncDataTable;
    const toggleBtn = $('.toggle-rows-btn');
    let expandedCount = 0;
    let totalRows = 0;

    api.rows({ page: 'current' }).every(function (rowIdx) {
      const row = this;
      totalRows++;
      if (row.child.isShown()) {
        expandedCount++;
      }
    });

    // Update button based on majority state
    if (expandedCount === totalRows && totalRows > 0) {
      // All rows expanded
      toggleBtn.html('<i class="fas fa-compress-alt me-1"></i> Collapse All');
      allRowsExpanded = true;
    } else if (expandedCount === 0) {
      // All rows collapsed
      toggleBtn.html('<i class="fas fa-expand-alt me-1"></i> Expand All');
      allRowsExpanded = false;
    } else {
      // Mixed state - show expand option
      toggleBtn.html('<i class="fas fa-expand-alt me-1"></i> Expand All');
      allRowsExpanded = false;
    }
  }

  // Add this function after the existing functions (around line 150)
  $scope.resetActionPanel = function () {
    $scope.action_panel_to_display = 'main';

    // Optional: Clear any form data when going back to main
    // Uncomment these lines if you want to clear the fields when going back
    // $scope.modal_action_issue.owner_name_cad = '';
    // $scope.modal_action_issue.other_agent_name = '';

    safeApply($scope);
  }

  // Add these variables at the top with other scope variables
  $scope.editingNote = false;
  $scope.currentNote = { content: '' };
  $scope.modal_action_notes = []; // Initialize notes array
  let note_modal_ref = null;

  // Add these functions after the existing functions

  $scope.addNote = function () {
    $scope.editingNote = false;
    $scope.currentNote = { content: '' };
    note_modal_ref.show();
  }

  $scope.editNote = function (note) {
    $scope.editingNote = true;
    $scope.currentNote = {
      id: note.id,
      content: note.note,
      user: note.user,
      created_at: note.created_at
    };
    note_modal_ref.show();
  }

  $scope.saveNote = async function () {
    if (!$scope.currentNote.content || $scope.currentNote.content.trim() === '') {
      return;
    }

    const noteData = {
      issue_id: $scope.modal_action_issues_id,
      note: $scope.currentNote.content.trim(),
      user: $scope.user_info.initials || 'Current User' // Use actual user info
    };

    console.log('$scope.user_info :>> ', $scope.user_info);
    console.log('noteData :>> ', noteData);

    try {
      const result = await cadSyncService.saveNote(noteData);
      console.log('result.data :>> ', result.data);

      if (result.data.success) {
        // Add the new note to the local array
        $scope.modal_action_notes.push({
          id: result.data.data.id,
          issue_id: $scope.modal_action_issues_id,
          note: result.data.data.note,
          user: result.data.data.user,
          created_at: new Date().toISOString()
        });

        $scope.currentNote = { content: '' };
        safeApply($scope);
      } else {
        alert('Error saving note');
      }
    } catch (error) {
      console.error('Error saving note:', error);
      alert('Error saving note');
    }
  }

  $scope.updateNote = async function () {
    if (!$scope.currentNote.content || $scope.currentNote.content.trim() === '') {
      return;
    }

    const noteData = {
      id: $scope.currentNote.id,
      note: $scope.currentNote.content.trim()
    };

    try {
      // Replace with your actual API call
      const result = await cadSyncService.updateNote(noteData);

      if (result.data.success) {
        // Update the note in the local array
        const noteIndex = $scope.modal_action_notes.findIndex(n => n.id === $scope.currentNote.id);
        if (noteIndex !== -1) {
          $scope.modal_action_notes[noteIndex].note = noteData.note;
          $scope.modal_action_notes[noteIndex].updated_at = new Date().toISOString();
        }

        $scope.currentNote = { content: '' };
        $scope.editingNote = false;
        safeApply($scope);
      } else {
        alert('Error updating note');
      }
    } catch (error) {
      console.error('Error updating note:', error);
      alert('Error updating note');
    }
  }

  $scope.deleteNote = async function (note) {
    try {
      // Replace with your actual API call
      const result = await cadSyncService.deleteNote({ id: note.id });

      if (result.data.success) {
        // Remove the note from the local array
        const noteIndex = $scope.modal_action_notes.findIndex(n => n.id === note.id);
        if (noteIndex !== -1) {
          $scope.modal_action_notes.splice(noteIndex, 1);
        }

        safeApply($scope);
      } else {
        alert('Error deleting note');
      }
    } catch (error) {
      console.error('Error deleting note:', error);
      alert('Error deleting note');
    }
  }

  // Add these methods to your controller
  $scope.noteToDelete = null;

  $scope.showDeleteConfirmation = function (note) {
    $scope.noteToDelete = note;
    $('#delete_note_modal').modal('show');
  };

  $scope.confirmDeleteNote = function () {
    if ($scope.noteToDelete) {
      $scope.deleteNote($scope.noteToDelete);
      $scope.noteToDelete = null;
    }
  };

  // Function to load notes for the current issue
  async function loadNotesForIssue(issuesId) {
    console.log('****** issuesId :>> ', issuesId);
    try {
      // Replace with your actual API call
      const result = await cadSyncService.loadNotes({ issue_id: issuesId });

      if (result.data.success) {
        $scope.modal_action_notes = result.data.data || [];
        safeApply($scope);
      } else {
        $scope.modal_action_notes = [];
        console.warn('No notes found for issue:', issuesId);
      }
    } catch (error) {
      console.error('Error loading notes:', error);
      $scope.modal_action_notes = [];
    }
  }
})